import { motion } from "framer-motion";
import { useEffect, useState } from "react";

export default function InspirationButton({ onClick, className = "" }) {
  const [flash, setFlash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setFlash(false), 2500); // run shimmer once
    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.button
      onClick={onClick}
      whileHover={{ scale: 1.03 }}
      whileTap={{ scale: 0.97 }}
      className={`relative w-full flex items-center justify-center px-6 py-3 rounded-3xl text-white shadow-lg bg-gradient-to-r from-sage to-sagedark overflow-hidden ${className}`}
    >
      <span className="relative z-10">Inspire me</span>

      {/* one-time shimmer */}
      {flash && (
        <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent shimmer-once" />
      )}
    </motion.button>
  );
}
